import { getRegisterFunction } from '../../utils/register.js';
import { OneUxPillElement } from './OneUxPillElement.js';
export const register = getRegisterFunction(OneUxPillElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-pill': OneUxPillElement;
    "pill-2f7b0580f9cdfcf1262dcb8fffa79cc2": OneUxPillElement;
  }
}